var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fid-slideshow',{attrs:{"slides-url":_vm.slidesUrl,"departures-url":_vm.departuresUrl,"station":_vm.station,"source":_vm.source}})}
var staticRenderFns = []

export { render, staticRenderFns }